import React, { useEffect, useCallback, useState} from 'react';
import {OPERATORS_MIXER} from 'constants/pullable-types.js';
import {setPullablePartDragging} from 'actions/index.js';
import OperatorDetails from './OperatorDetails.js';
import WaveformSelector from './WaveformSelector.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Notes from 'midi/Notes.js';
import OperatorMixer from './OperatorMixer.js';
import {connect} from 'react-redux';

const OperatorsMixer = ({
    formantsExpanded,
    setFormantsExpanded,
    setPullablePartDragging,
    instrument,
    isDraggable=true,
    sequencerEngine,
    setShowWaveform,
    setOscillatorDetails,
    oscillatorDetails,
    color
}) => { 
    let oscillators = instrument.oscillatorNodes;
    let [oscWaveforms, setOscWaveforms] = useState(undefined);
    let [oscDragging, setOscDragging] = useState(undefined);

    const onDragStart = useCallback(() => {
        setPullablePartDragging({
            instrument,
            id: instrument.id,
            track: instrument.track,
            type: OPERATORS_MIXER
        });
    }, [instrument]);

    return (
        <div
          /*
          onDragStart={onDragStart}
          onDragOver={(e) => e.preventDefault()}
          draggable={isDraggable}
        */
          className={formantsExpanded ? "operators-mixer expanded" : "operators-mixer"}>
          <div className="mixers">
            {oscillators.map(
                osc =>
                    <OperatorMixer
                      key={osc.id}
                      setOscillatorDetails={setOscillatorDetails}
                      color={color}
                      oscWaveforms={oscWaveforms}
                      setOscWaveforms={setOscWaveforms}
                      oscDragging={oscDragging}
                      setOscDragging={setOscDragging}
                      oscillatorDetails={oscillatorDetails}
                      oscillator={osc}
                      setShowWaveform={setShowWaveform}/>)}
          </div>
          {!oscillatorDetails ? 
           <div className="global-parameters">
           <EffectParameterSlider
             sequencerEngine={instrument.sequencerEngine}
             name={'Root Note'}
             parameter={
                 instrument.carrier.oscillatorFrequencyParameter}
             onParameterChanged={() => instrument.releaseAll()}
             displayFunction={(x) => Notes.fromTranspose(x).toString()}
             isParameter={true}
             min={-32}
             max={32}
             step={1}
           />
          <EffectParameterSlider
             sequencerEngine={instrument.sequencerEngine}
             name={'Detune'}
             parameter={
                 instrument.detuneParameter}
             isParameter={true}
             lfoEnabled={true}
             min={-100}
             max={100}
             step={1}
           />
           </div>
           :
           <OperatorDetails 
             formantsExpanded={formantsExpanded}
             setFormantsExpanded={setFormantsExpanded}
             oscillator={oscillatorDetails}/>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPullablePartDragging: x => dispatch(setPullablePartDragging(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorsMixer);
